import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeliveryinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M2 9V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12H3a1 1 0 0 1-1-1v-3m14.012-6h2.891a2 2 0 0 1 1.442.614l2.097 2.18A2 2 0 0 1 23 11.181V17h-7l.012-10z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 6.5,
				cy: 18.5,
				r: 1.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 19.5,
				cy: 18.5,
				r: 1.5
			}),
			/* @__PURE__ */ _jsx("path", { d: "M1 9h7" })
		]
	})
});
export default SvgDeliveryinline;
